/**
 * Event name when the dropdown is changed
 */
export const ADVERTISING_ANALYTICS_EVENT = 'advertisingAnalyticsEvent';
